module.exports = __webpack_public_path__ + "static/media/plus-footer.bfdc086d.svg";